import { AnalyticsGTM, IAnalytics } from '@quicktools/shared-components/services/analytics-gtm';
import ReactGA4 from 'react-ga4';
import { GA4 } from 'react-ga4/types/ga4';

import { TOOL_NAME, VERSION } from '../../configs';

export const exportMap: { [key: string]: string } = {
  pdf: 'save_pdf',
  qr: 'get_qr_code',
  copy: 'link_copy',
};

const page_name = 'main';

class Analytics extends AnalyticsGTM {
  constructor(public options: IAnalytics, ga4Instance: GA4) {
    super(options, ga4Instance);
  }

  pageOpen() {
    this.sendGaEvent('page_open', {
      page_name,
      non_interaction: true,
    });
  }

  event(action: string) {
    this.sendGaEvent(action, {
      page_name,
      tool_name: TOOL_NAME,
    });
    this.hjEvent(action);
  }

  eventWithType(action: string, action_type: string) {
    this.sendGaEvent(action, {
      page_name,
      tool_name: TOOL_NAME,
      action_type,
    });
  }

  fileDownload(action_type: string) {
    this.sendGaEvent('file_download', {
      page_name,
      tool_name: TOOL_NAME,
      action_type,
    });
  }
}

export default new Analytics(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);
